import { BaseButtons, BaseForm, BaseGridLayout, useModal, BaseModal, sx } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { LINK_FORM_GENERICA } from 'configuration/link'
import ConfigManager from 'components/config/ConfigManager'
import Titoletto from 'components/ui/Titoletto'
import useSchermoStretto from 'hook/useSchermoStretto'

const CFG = LINK_FORM_GENERICA

export default function SezioneForm(props) {
  const {
    titolo,
    defaultValues,
    onSubmit,
    Riassunto,
    children,
    propsBottoneModifica,
    propsBottoneConferma,
    propsBottoneAnnulla,
    propsTitolo,
    propsModal,
    ...propsForm
  } = props

  const { modalRef, openModal, closeModal } = useModal()

  const schermoStretto = useSchermoStretto()

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_LINK_FORM_GENERICA]}
      render={({ val }) =>
        <>
          <BaseGridLayout justifySpaceBetween alignCenter>
            {titolo && <Titoletto variant='h5' {...propsTitolo}>{titolo}</Titoletto>}
            <BaseButtons.Modifica
              testo={val(CFG.MODIFICA)}
              size='small'
              onClick={openModal}
              {...propsBottoneModifica}
              {...sx(propsBottoneModifica, { mb: 1, mt: 0 })}
            />
          </BaseGridLayout>

          {Riassunto(defaultValues)}

          <BaseModal
            ref={modalRef}
            maxWidth='lg'
            fullScreen={schermoStretto}
            contenutoNonCentrato
            {...(schermoStretto && { propsContenuto: { sx: { p: 2 } } })}
            {...propsModal}
          >
            <BaseForm
              defaultValues={defaultValues}
              onSubmit={async valori => {
                const { ok } = await onSubmit(valori)
                if (ok) closeModal()
              }}
              disabilitaSubmitTastiera
              messaggioValidazioneRequired={val(CFG.CAMPO_OBBLIGATORIO)}
              {...propsForm}
            >
              {titolo && <Titoletto variant='h5' {...propsTitolo}>{titolo}</Titoletto>}

              {children}

              <BaseGridLayout sx={{ mt: 0 }} justifyCenter>
                <BaseButtons.Conferma
                  testo={val(CFG.CONFERMA)}
                  submit
                  {...propsBottoneConferma}
                />
                <BaseButtons.Annulla
                  testo={val(CFG.ANNULLA)}
                  color='default'
                  onClick={closeModal}
                  {...propsBottoneAnnulla}
                />
              </BaseGridLayout>
            </BaseForm>
          </BaseModal>
        </>
      }
    />
  )
}